import axios from 'axios'
export const formatAvailableCredits = (credits: number): string =>
  credits > 9999999 ? 'Ilimitado' : String(credits)

export const getAddUserErrorMessage = (error: unknown): string => {
  if (axios.isAxiosError<{ message?: string }>(error)) {
    const message = error.response?.data?.message
    const status = error.response?.status
    const inventoryError =
      message === 'No hay suficientes créditos disponibles para agregar los usuarios' ||
      message === 'No hay inventarios activos con créditos disponibles para las pruebas de este proceso'
    if (typeof message === 'string' && message.trim() && ((status !== undefined && status < 500) || inventoryError)) {
      return message
    }
  }

  return 'No se pudo agregar el usuario. Inténtalo de nuevo.'
}
